/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  Button, TextField,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import elearningDetailsServices from '../../redux/services/elearningDetailsServices';
import { toastError, toastSuccess } from '../../redux/actions/alertActions';

const TeacherBill = ({ examDataLv1, teacherBillProps }) => {
  const [teacherBill, setTeacherBill] = useState('');

  useEffect(() => {
    setTeacherBill(teacherBillProps);
  }, []);

  const handleTeacherBill = (e) => {
    setTeacherBill(e.target.value);
  };

  const saveTeacherBill = async () => {
    elearningDetailsServices.updateElearningOption(examDataLv1.examId, { teacherBill })
      .then((res) => {
        toastSuccess('Date facturation formateur mise à jour.');
      })
      .catch((err) => {
        toastError('Echec de la mise à jour.');
      });
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <TextField
        value={teacherBill}
        variant="outlined"
        multiline
        rows={0}
        onChange={handleTeacherBill}
        inputProps={{
          style: {
            color: '#6b6b6b',
            fontSize: '13px',
          },
        }}
      />
      <Button
        variant="outlined"
        color="primary"
        size="small"
        style={{
          marginTop: '10px',
          fontSize: '10px',
          alignSelf: 'flex-end',
        }}
        onClick={saveTeacherBill}
      >
        Save
      </Button>
    </div>
  );
};

TeacherBill.propTypes = {
  teacherBillProps: PropTypes.string.isRequired,
  examId: PropTypes.string.isRequired,
};

export default TeacherBill;
